import { dataSchema } from '@ragu-components/ord-types';

import type { AgentSettings } from '@ragu-components/ord-types';

export const agentSettingsFields: Array<keyof AgentSettings> = [
  'busy_delay_time',
  'call_timeout',
  'no_answer_delay_time',
  'position',
  'reject_delay_time',
  'wrap_up_time',
];

export const agentSettingsProperties = dataSchema.AgentSettings.properties;

export type AgentSettingField = (typeof agentSettingsFields)[number];
